/**
 * Module dependencies.
 */

import { availableFiltersKeys } from 'src/core/collections-config/filters';
import { recycleMaterial } from 'src/core/collections-config/recycle-material';

import { useFiltersList } from 'src/context/filters-list/context';
import { useTranslate } from 'src/core/utils/translator';
import FilterDisclosure from 'src/components/filters/filter-disclosure';
import FilterItem from 'src/components/filters/filter-item';
import FilterItemLabel from 'src/components/filters/filter-item-label';
import React, { ReactElement } from 'react';
import keys from 'lodash/keys';
import split from 'lodash/split';

/**
 * Filter name.
 */

const filterName = availableFiltersKeys.recycleMaterial;

/**
 * `Props` type.
 */

type Props = {
  filtersList?: string[];
};

/**
 * `RecycleMaterialFilter` component.
 */

const RecycleMaterialFilter = ({ filtersList }: Props): ReactElement => {
  const { translate } = useTranslate();
  const { filters } = useFiltersList();
  const hasFilter = keys(filters).includes(filterName);
  const selectedFilters = hasFilter ? split(filters[filterName], ',').map(value => `${value}%`) : [];

  const valuesList = filtersList?.length
    ? Object.values(recycleMaterial).filter(value => filtersList.includes(value))
    : Object.values(recycleMaterial);

  return (
    <FilterDisclosure
      name={filterName}
      selectedFilters={selectedFilters}
      title={translate('collections:labels.recycleMaterial')}
    >
      {valuesList.map((value: string) => (
        <FilterItem
          key={value}
          label={(
            <FilterItemLabel
              title={`${value}%`}
            />
          )}
          name={filterName}
          value={value}
        />
      ))}
    </FilterDisclosure>
  );
};

/**
 * Export `RecycleMaterialFilter` component.
 */

export default RecycleMaterialFilter;
